(function () {
  'use strict';

  // ADVANCED URL SANITIZATION
  function sanitizeUrl(url) {
    if (!url) return null;
    
    url = url.trim();
    
    try {
      const urlObj = new URL(url, window.location.origin);
      
      // Whitelist Secure Protocols
      const allowedProtocols = ['http:', 'https:', 'data:'];
      if (!allowedProtocols.includes(urlObj.protocol)) {
        console.warn('Protocollo non permesso:', urlObj.protocol);
        return null;
      }
      
      // Block potentially dangerous URL
      if (urlObj.protocol === 'data:') {
        const dataPrefix = url.substring(0, 100).toLowerCase();
        // Permetti solo immagini
        if (!dataPrefix.match(/^data:image\/(png|jpeg|jpg|gif|webp|svg\+xml);base64,/)) {
          console.warn('Data URL non permesso (solo immagini base64)');
          return null;
        }
      }
      
      return urlObj.href;
    } catch (e) {
      console.warn('URL non valido:', url);
      return null;
    }
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function isMobileTablet() {
    return window.matchMedia && window.matchMedia('(max-width: 1024px)').matches;
  }

  // Parametrics
  function applyResponsiveBackgrounds(hero) {
    const slides = qsa(hero, '.heronew__slide');
    const useMobile = isMobileTablet();

    slides.forEach(slide => {
      const url = useMobile ? slide.dataset.bgMobile : slide.dataset.bgDesktop;
      
      if (url) {
        const safeUrl = sanitizeUrl(url);
        
        if (safeUrl) {
          // setProperty
          // Escaping
          slide.style.setProperty('background-image', `url(${safeUrl})`);
        } else {
          // Rimuovi background se URL non valido
          slide.style.removeProperty('background-image');
          console.error('Background non applicato per URL non sicuro');
        }
      } else {
        // Nessun URL specificato, rimuovi background esistente
        slide.style.removeProperty('background-image');
      }
    });
  }

  function initHeroPro(hero) {
    if (!hero) return;

    if (hero._heroPro && typeof hero._heroPro.destroy === 'function') {
      hero._heroPro.destroy();
    }

    const slides = qsa(hero, '.heronew__slide');
    const contents = qsa(hero, '.heronew__content');
    const dots = qsa(hero, '.heronew__dots button');
    const prev = hero.querySelector('.heronew__arrow--prev');
    const next = hero.querySelector('.heronew__arrow--next');

    function applyNavigationVisibility() {
      const isMobile = isMobileTablet();

      // Boolean validation
      const navEnabled = (isMobile ? hero.dataset.navMobile : hero.dataset.navDesktop) === 'true';
      const dotsEnabled = (isMobile ? hero.dataset.dotsMobile : hero.dataset.dotsDesktop) === 'true';
      const arrowsEnabled = (isMobile ? hero.dataset.arrowsMobile : hero.dataset.arrowsDesktop) === 'true';

      const shouldShowNav = navEnabled && slides.length > 1;

      // setProperty
      const dotsWrap = hero.querySelector('.heronew__dots');
      if (dotsWrap) {
        dotsWrap.style.setProperty('display', (shouldShowNav && dotsEnabled) ? 'flex' : 'none');
      }

      const showArrows = shouldShowNav && arrowsEnabled;
      if (prev) prev.style.setProperty('display', showArrows ? 'block' : 'none');
      if (next) next.style.setProperty('display', showArrows ? 'block' : 'none');
    }

    if (!slides.length) return;

    let index = 0;
    let autoplayTimer = null;

    // Numerics validation
    const autoplayDelay = Math.max(1000, Math.min(30000, Number(hero.dataset.autoplayDelay) || 5000));
    const enableAutoplay = hero.dataset.autoplay === 'true';
    const enableSwipeSetting = hero.dataset.swipeMobile === 'true';

    slides.forEach((s, i) => {
      if (s.classList.contains('is-active')) index = i;
    });

function show(i) {
  const validIndex = Math.max(0, Math.min(slides.length - 1, i));

  slides.forEach(s =>
    s.classList.toggle('is-active', Number(s.dataset.index) === validIndex)
  );

  contents.forEach(c =>
    c.classList.toggle('is-active', Number(c.dataset.index) === validIndex)
  );

  if (dots && dots.length) {
    dots.forEach(d =>
      d.classList.toggle('is-active', Number(d.dataset.index) === validIndex)
    );
  }

  index = validIndex;
}
    function nextSlide() {
      show((index + 1) % slides.length);
    }

    function prevSlide() {
      show((index - 1 + slides.length) % slides.length);
    }

    function startAutoplay() {
      if (!enableAutoplay || slides.length <= 1) return;
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    const onNext = () => { nextSlide(); startAutoplay(); };
    const onPrev = () => { prevSlide(); startAutoplay(); };

    if (next) next.addEventListener('click', onNext);
    if (prev) prev.addEventListener('click', onPrev);

    const dotHandlers = [];
    if (dots && dots.length) {
dots.forEach(dot => {
  const targetIndex = Number(dot.dataset.index);
  const fn = () => { show(targetIndex); startAutoplay(); };        dot.addEventListener('click', fn);
        dotHandlers.push([dot, fn]);
      });
    }

    // SWIPE GESTURE HANDLING
    let startX = 0, startY = 0, endX = 0, endY = 0;
    const THRESHOLD = 50;
    const VERTICAL_LIMIT = 30;

    const canSwipeNow = () => enableSwipeSetting && isMobileTablet();

    const onTouchStart = (e) => {
      if (!canSwipeNow() || !e.touches || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      endX = startX;
      endY = startY;
    };

    const onTouchMove = (e) => {
      if (!canSwipeNow() || !e.touches || e.touches.length !== 1) return;
      endX = e.touches[0].clientX;
      endY = e.touches[0].clientY;

      if (Math.abs(endX - startX) > Math.abs(endY - startY)) {
        e.preventDefault();
      }
    };

    const onTouchEnd = () => {
      if (!canSwipeNow()) return;

      const dx = endX - startX;
      const dy = endY - startY;

      if (Math.abs(dy) > VERTICAL_LIMIT || Math.abs(dx) < THRESHOLD) return;

      dx < 0 ? nextSlide() : prevSlide();
      startAutoplay();
    };

    hero.addEventListener('touchstart', onTouchStart, { passive: true });
    hero.addEventListener('touchmove', onTouchMove, { passive: false });
    hero.addEventListener('touchend', onTouchEnd, { passive: true });

    applyResponsiveBackgrounds(hero);
    applyNavigationVisibility();
    
    const onResize = () => {
      applyResponsiveBackgrounds(hero);
      applyNavigationVisibility();
    };
    window.addEventListener('resize', onResize);

/* =========================
PAUSE ON HOVER / TOUCH
========================= */

hero.addEventListener('mouseenter', stopAutoplay);
hero.addEventListener('mouseleave', startAutoplay);

hero.addEventListener('touchstart', stopAutoplay);

hero.addEventListener('touchend', function(){
setTimeout(startAutoplay, 2000);
});

    startAutoplay();

    hero._heroPro = {
      destroy: function () {
        stopAutoplay();
        if (next) next.removeEventListener('click', onNext);
        if (prev) prev.removeEventListener('click', onPrev);

        dotHandlers.forEach(([el, fn]) => {
          el.removeEventListener('click', fn);
        });

        hero.removeEventListener('touchstart', onTouchStart);
        hero.removeEventListener('touchmove', onTouchMove);
        hero.removeEventListener('touchend', onTouchEnd);
        window.removeEventListener('resize', onResize);

        hero._heroPro = null;
      }
    };
  }

  function initAll(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-hero-pro]').forEach(initHeroPro);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  document.addEventListener('shopify:section:load', (event) => {
    if (event?.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    if (event?.target) initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!event?.target) return;
    event.target.querySelectorAll('[data-hero-pro]').forEach(hero => {
      hero._heroPro?.destroy?.();
    });
  });

})();

